<template>
  <div>
    <ul class="pagination pagination-sm">
      <li
        v-for="(txt, txtindex) in text"
        :key="txtindex"
        v-bind:class="{ active: txtindex == selectedText }"
        class="page-item"
      >
        <a class="page-link" @click="selectedText = txtindex">{{
          txtindex + 1
        }}</a>
      </li>
      <li class="page-item">
        <a class="page-link" @click="addMessage()">+</a>
      </li>
    </ul>
    <textarea
      v-if="isStringMessage"
      class="form-control"
      :class="{ 'is-invalid': hasErrors }"
      v-model="currentText"
      @input="emit"
      :rows="rows"
      :disabled="disabled"
    >
"</textarea
    >
    <div v-else>
      <gif-message
        v-if="currentText.type === 1"
        :message="currentText"
      ></gif-message>
      <gift-message
        v-else-if="currentText.type === 2"
        :message="currentText"
      ></gift-message>
      <blink-message v-else-if="currentText.type === 3"></blink-message>
      <img
        v-else-if="currentText.type === 4"
        :src="currentText.meta.url"
        style="max-width:100%"
      />
      <span v-else>
        {{ currentText }}
      </span>
    </div>
    <div v-if="isStringMessage">
      <div @click="addPlaceholder('{sender-name}')" class="btn btn-secondary">
        Profilname Absender
      </div>
      <div @click="addPlaceholder('{sender-age}')" class="btn btn-secondary">
        Alter vom Absender
      </div>
      <div @click="addPlaceholder('{receiver-name}')" class="btn btn-secondary">
        Profilname Empfänger
      </div>
      <div @click="addPlaceholder('{receiver-age}')" class="btn btn-secondary">
        Alter vom Empfänger
      </div>
    </div>
    <button type="button" class="btn btn-danger" @click="deleteMessage()">
      Nachricht löschen
    </button>
    <chat-input-buttons
      :can-send-image="canSendImage"
      @send-gif="addGif"
      @send-gift="addGift"
      @add-emoji="addPlaceholder($event.colons)"
      @send-blink="addBlink"
      @send-image="addImage"
    >
    </chat-input-buttons>
    <div
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script lang="babel">
import Vue from "vue";
import ChatInputButtons from "@/components/Customer/chat/ChatInputButtons";
import GifMessage from "@/components/Customer/messages/GifMessage";
import BlinkMessage from "@/components/Customer/messages/BlinkMessage";
import GiftMessage from "@/components/Customer/messages/GiftMessage";

export default {
  components: {
    ChatInputButtons,
    GifMessage,
    BlinkMessage,
    GiftMessage
  },
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    }
  },
  data() {
    return {
      text: [""],
      selectedText: 0,
    };
  },
  mounted() {
    if (this.value !== null) {
      this.text = this.value.slice();
    }
    this.emit()
  },
  computed: {
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    rows() {
      return this.attribute.rows === undefined ? 3 : this.attribute.rows;
    },
    disabled() {
      return Boolean(this.attribute.disabled);
    },
    currentText: {
      get() {
        return this.text[this.selectedText];
      },
      set(newVal) {
        this.text[this.selectedText] = newVal;
      }
    },
    isStringMessage() {
      return typeof this.currentText === 'string';
    },
    currentFake() {
      return this.$store.getters["moderation/fake"];
    },
    canSendImage() {
      return this.currentFake !== null;
    }
  },
  methods: {
    addMessage() {
      this.text.push("");
      this.selectedText = this.text.length-1;
    },
    deleteMessage() {
      this.text.splice(this.selectedText, 1);
      this.selectedText--;

      if (this.text.length <= 0)
        this.text.push("");

      if (this.selectedText < 0)
        this.selectedText = 0;
      this.emit();
    },
    emit() {
      this.$emit("input", this.text);
    },
    addPlaceholder(text) {
      if(this.isStringMessage) {
        Vue.set(this.text, this.selectedText, this.text[this.selectedText] + text);
      }
    },
    addGif(event) {
      this.text.push({
        type: 1,
        meta: {url: event}
      });
      this.emit();
    },
    addGift(event) {
      this.text.push({
        type: 2,
        meta: {giftId: event}
      });
      this.emit();
    },
    addBlink() {
      this.text.push({
        type: 3
      });
      this.emit();
    },
    addImage(event) {
      this.text.push({
        type: 4,
        meta: {id: event.id, url: event.url}
      })
      this.emit();
    },
    clearImageMessages() {
      this.text = this.text.filter(text => typeof text === 'string' || text.type !== 4)
    }
  },
  watch: {
    currentFake(newVal, oldVal) {
      if(!newVal || (oldVal && newVal.id !== oldVal.id)) {
        this.clearImageMessages();
      }
    }
  }
}
</script>
